import React, { useMemo } from 'react';

import { Tooltip } from '@swyftx/aviary/atoms/Tooltip/Tooltip';
import { Numeric } from '@swyftx/aviary/atoms/Typography';

import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';

type Props = {
  value?: number | null;
};

const MarginPositionsTableOpenedTime: React.FC<Props> = observer(({ value }) => {
  const timeSince = useMemo(() => {
    if (!value) return undefined;

    const givenDate = DateTime.fromMillis(value);

    // Current date
    const now = DateTime.now();

    // Calculate the difference
    const { days, hours, minutes, seconds } = now.diff(givenDate, ['days', 'hours', 'minutes', 'seconds']).toObject();

    const d = days ? `${days}d ` : ``;
    const h = hours ? `${hours}h ` : ``;
    const m = minutes ? `${minutes}min ` : ``;
    const s = seconds ? `${seconds.toFixed(0)}sec ` : ``;

    return `${d}${h}${m}${s} ago`;
  }, [value]);

  return (
    <Tooltip title={timeSince}>
      <span>
        <Numeric className='whitespace-nowrap'>
          {value ? DateTime.fromMillis(value).toFormat('dd/MM/yyyy hh:mm:ss a') : '-'}
        </Numeric>
      </span>
    </Tooltip>
  );
});

export { MarginPositionsTableOpenedTime };
